export const environment = {
  production: true,
  env: 'prod',
  recaptcha: '6Lf_6jsqAAAAAKMWf0BNO7qTD0HpWcy0m6w6D1kZ',
  api_v1_url: 'https://public-api.snapmatic.me',
  api_v2_url: 'https://sapi-v2.snapmatic.me',
  assets_url: 'https://uploads.snapmatic.me/',
  ws_url: 'wss://ws.snapmatic.me/',
  // Client branch: sentry_environment is the client name.
  sentry_dsn: 'https://c0e3871c46d8c2d7c9776558029b2e9c@sentry.analog-robot.com/5',
  sentry_environment: 'will-power',
  distribution: { // make sure numbers add up to 100
    "awaiting": 0,
    "update_input_completed": 0,
    "fetched": 1,
    "running_detection": 4,
    "detection_completed": 7,
    "training": 10,
    "generation": 74,
    "uploading": 3,
    "complete": 1,
  },
  stages: {
    "awaiting": "analysing uniqueness",
    "update_input_completed": "analysing uniqueness",
    "fetched": "ai processing slot allocated",
    "running_detection": "analysing uniqueness",
    "detection_completed": "awaiting ai processing slot",
    "training": [
      "training ai",
      "computing poses",
      "detecting features",
      "applying physiognomy",
      "reading facial microexpressions"
    ],
    "generation": [
      "calculating uniqueness",
      "computing poses",
      "detecting features",
      "applying physiognomy",
      "reading facial microexpressions",
      "applying creativity"
    ],
    "uploading": "preparing results",
    "complete": "complete",
    "generation_error": "generation error"
  }
};
